// Converted to TypeScript
/* Add appropriate types here */
/***
 *
 *   Signup form for account owners
 *
 **********/

import { useContext, useState } from "react";
import { Link, Logo, ViewContext, useNavigate } from "@/components/lib";
import { useForm } from "react-hook-form";
import Styles from "@/css/mainStyles";
import axios from "axios";

export function Signup() {
  const viewContext = useContext<any>(ViewContext);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  const onSubmit = async (data: any) => {
    data.shirt = Number(data.shirt);
    try {
      await axios({
        method: "post",
        url: "/api/account/request",
        data
      });
      localStorage.setItem("emailghs", data.email);
      navigate("/signup/verify-email");
      setSent(true);
    } catch (error) {
      console.error(error);
      let message = error.response?.data?.message
        ? error.response.data.message
        : error.message;
      if (message === "Validation Error in body" && error.response.data?.errors?.[0]?.message) {
        message = error.response.data.errors[0].message;
      }
      viewContext.notification.show(message, "error");
    }
  };

  return (
    <div className="flex flex-col justify-center h-screen p-8 md:px-32 text-left">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <h1 className="font-bold text-2xl lg:text-4xl">Create Your Account</h1>
      <h2 className="mt-3 text-xl">
        You must be a current Grapevine Varsity football player to sign up. 
        Please fill out the form below and we will create your access.
      </h2>
      <form
        className="flex flex-col gap-6 mt-7"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="grid grid-cols-2 gap-3">
          <div className="flex flex-col flex-1 w-full">
            <label className={Styles.label}>First Name</label>
            <input
              placeholder="Enter First Name"
              type="text"
              className={sent ? "opacity-40 cursor-default " + Styles.input : Styles.input}
              {...register("first_name", { required: true })}
              style={errors.first_name && { border: "1px solid red" }}
              disabled={sent}
            />
            {errors.first_name && (
              <p className={Styles.error}>First name is required</p>
            )}
          </div>
          <div className="flex flex-col flex-1 w-full">
            <label className={Styles.label}>Last Name</label>
            <input
              placeholder="Enter Last Name"
              type="text"
              className={sent ? "opacity-40 cursor-default " + Styles.input : Styles.input}
              {...register("last_name", { required: true })}
              style={errors.last_name && { border: "1px solid red" }}
              disabled={sent}
            />
            {errors.last_name && (
              <p className={Styles.error}>Last name is required</p>
            )}
          </div>
        </div>
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Football Number</label>
          <input
            placeholder="Enter Football Number"
            type="number"
            min={0}
            max={99}
            className={Styles.input}
            {...register("shirt", { required: true })}
            style={errors.shirt && { border: "1px solid red" }}
            disabled={sent}
          />
          {errors.shirt && (
            <p className={Styles.error}>Football number is required</p>
          )}
        </div>
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Email</label>
          <input
            placeholder="Enter Email"
            type="email"
            className={Styles.input}
            {...register("email", { required: true })}
            style={errors.email && { border: "1px solid red" }}
            disabled={sent}
          />
          {errors.email && <p className={Styles.error}>Email is required</p>}
        </div>
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Password</label>
          <input
            placeholder="Enter Password"
            type="password"
            className={Styles.input}
            {...register("password", { required: true })}
            style={errors.password && { border: "1px solid red" }}
            disabled={sent}
          />
          {errors.password && (
            <p className={Styles.error}>Password is required</p>
          )}
        </div>
        <input
          type="submit"
          value="Continue"
          className={ sent ? "pointer-events-none cursor-default opacity-60 " + Styles.submitButton : Styles.submitButton }
          disabled={sent}
        />
      </form>

      <div className="mt-4 text-center flex justify-center gap-2">
        <p style={{ color: "#454C54" }}>Do you already have an account?</p>
        <Link url="/signin" text="Log In" color="white" noUnderline />
      </div>
    </div>
  );
}
